import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';

import { useStores } from '../../../utils/hooks';

import { Dropdown } from './dropdown';

export interface SortProps {
  inDialog?: boolean;
}

export const Sort: React.FC<SortProps> = ({ inDialog }) => {
  const { activitySearchStore } = useStores();
  const sortSections = activitySearchStore.universalSortAndFilter?.sortSections;
  if (!sortSections) {
    return <></>;
  }

  return (
    <>
      {sortSections.map((sortSection: ActivityDestinationViewSearch.SortSections, index: number) => (
        <UitkSpacing key={index} margin={{ blockend: 'four', blockstart: 'two' }} padding={{ blockend: 'four' }}>
          <section key={index} data-testid="sort-section">
            {sortSection.fields.map((field: ActivityDestinationViewSearch.Fields, fieldIndex: number) => {
              switch (field.__typename) {
                case 'ShoppingDropdownField':
                  return (
                    <Dropdown key={`dropdown-${fieldIndex}`} field={field} inDialog={inDialog} title={field.primary} />
                  );
                default:
                  return <></>;
              }
            })}
          </section>
        </UitkSpacing>
      ))}
    </>
  );
};
